import React from 'react';
import { useLocation } from 'react-router-dom';
import DoctorDefault from '../../assets/images/DoctorDefault.png';
import { useAppState } from '../../state';
import Logo from '../Logo/Logo';
import UserMenu from '../UserMenu/UserMenu';
import './IntroContainer.scss';

interface IntroContainerProps {
    children: React.ReactNode;
}

const IntroContainer = (props: IntroContainerProps) => {
    const { user } = useAppState();
    const location = useLocation();

    return (
        <div className="intro-block">
            <div className="intro-block__logo">
                <Logo />
            </div>
            {user && location.pathname !== '/login' && <UserMenu />}
            <div className="intro-block__container">
                <div className="intro-block__inner-container">
                    <div className="intro-block__doctor-hero-container">
                        <img
                            src={DoctorDefault}
                            className="intro-block__doctor_hero"
                            alt="doctor_default.png"
                        />
                    </div>
                    <div className="intro-block__content">{props.children}</div>
                </div>
            </div>
        </div>
    );
};

export default IntroContainer;
